  /////// series.html 分頁 ///////
    var btns = document.querySelectorAll('.btn');
    var contents = document.querySelectorAll('.content')

    for (let i = 0; i < btns.length; i++) {
        const index = i;
        const btn = btns[i]
        const content = contents[i]

        btns[i].onclick = function () {
            // console.log(index);

            remove_active();

            btn.classList.add('active');
            content.classList.add('active');
        }
    }
    function remove_active() {
        for (let i = 0; i < btns.length; i++) {
            btns[i].classList.remove('active');
            contents[i].classList.remove('active');
        }
    }
    /////// 分頁 ///////
